export const PROJECT_REQUEST_PAYMENT_TERM_OPTIONS = [
  { id: "Net 30", value: "Net 30" },
  { id: "Net 60", value: "Net 60" },
  { id: "Net 90", value: "Net 90" },
] as const;

export const formatPaymentTermLabel = (paymentTerm?: string | null): string =>
  paymentTerm?.trim() ? paymentTerm.trim() : "—";
